<template>
	<div :class="pageClasses">
		<div v-if="!isOnline" class="offlineOverlay">
			<div class="offlineOverlay-info">
				Wachten op connectie...
			</div>
		</div>
		<Content />
		<!--		<Loader ref="pageLoader" :opaque="true" /> -->
		<Notifications />
	</div>
</template>

<script src="./App.js"></script>
<style lang="scss">
	@import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css';
</style>
